import { render, staticRenderFns } from "./myPost.vue?vue&type=template&id=42a0cbd5&"
import script from "./myPost.vue?vue&type=script&lang=js&"
export * from "./myPost.vue?vue&type=script&lang=js&"
import style0 from "./myPost.vue?vue&type=style&index=0&id=42a0cbd5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports